<template>
<div :style="cssStyle || ''" :class="cssClass || ''" v-if="appliedChildren">
      <ComponentTree

        v-for="childNode in appliedChildren"
        v-bind:key="childNode?.lastUpdate"
        :children="childNode?.children"
        :__componentType="childNode?.componentType"
        :__id="childNode?.nodeUUID"
        :expression="childNode?.expression"
        :name="childNode?.name"
        :options="childNode?.options"
        :parameters="parameters"
        :node="childNode"
        :nodeUUID="childNode?.nodeUUID"
        :parentNodeUUID="childNode?.parentNodeUUID"
        :paused="childNode?.paused"
        :propsData="childNode?.propsData"
        v-bind="getNodeBindings(childNode)"

      >
        <slot></slot>
      </ComponentTree>

</div>
</template>
<script>
import { getTreeBindings } from "@/components/treeBindings.js";

export default {
  props: ["children", "cssClass", "cssStyle", "parameters", "byName"],
  name: "ChildrenTree",
  methods: {
    getNodeBindings(node) {
      return getTreeBindings(node, this.parameters, { childNode: node })
    }
  },
  computed: {
    appliedChildren() {
      let a = this.children ?  this.children : this.$parent.children
      if (!Array.isArray(a)) a = [a]

      // es un composite component (un componente del tenant con elementos hijos)
      if (!this.$parent.componentType) {
        return []
      }

      if (this.byName) a = this._.filter(a, el => el.name === this.byName)

      return a;
    }
  }

};
</script>
<style>

</style>
